import { memo } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Button from '@UI/Button';
import sofaImg from './sofa.svg';
import styles from './EmptyReview.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface EmptyReviewProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  onAddReview?: () => void;
}

const EmptyReview: FC<EmptyReviewProps> = (props) => {
  const { className, onAddReview, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <div className={styles.content}>
        <div className={styles.textContent}>
          <div className={styles.title}>{t('reviews.no-reviews')}</div>
          <div className={styles.text}>{t('reviews.want-know-your-opinion')}</div>
          <Button
            className={styles.button}
            onClick={onAddReview}
            data-testid='button-leave-feedback'
          >
            {t('reviews.add-review')}
          </Button>
        </div>
        <div className={styles.imgWrapper}>
          <img src={sofaImg} className={styles.img} />
        </div>
      </div>
    </div>
  );
};

export default memo(EmptyReview);
